module.exports = __webpack_public_path__ + "img/GAME_QUIZ.4ca6c370.png";